const translations = {
  "en": {
    "Cancel": "Cancel",
    "Confirm": "Confirm",
    "Market timing decides winners. Get alerts built around your portfolio and never miss your moment.": "Market timing decides winners. Get alerts built around your portfolio and never miss your moment.",
    "Personalized Notifications": "Personalized Notifications",
    "Turn Off Personalized Alerts?": "Turn Off Personalized Alerts?",
    "You'll lose tailored updates, and notice market moves too late.": "You'll lose tailored updates, and notice market moves too late."
  },
  "zh-tw": {
    "Cancel": "取消",
    "Confirm": "確認",
    "Market timing decides winners. Get alerts built around your portfolio and never miss your moment.": "市場時機決定勝負。根據你的投資組合設定通知，永遠不錯過你的時機。",
    "Personalized Notifications": "個人化通知",
    "Turn Off Personalized Alerts?": "關閉個人化通知？",
    "You'll lose tailored updates, and notice market moves too late.": "你將收不到客製化的更新，發現市場波動時已經太遲。"
  }
};

export default translations;
